module.exports = __webpack_public_path__ + "static/media/varais-14-copia.d3aa9301.jpg";